import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { CookieConsentService } from '@core/services/cookie-consent.service';
import { EnvironmentService } from '@core/services/environment.service';
import { IdleCallbackService } from '@core/services/idle-callback.service';
import { WINDOW } from '@core/services/window.service';

@Injectable({
    providedIn: 'root',
})
export class FacebookService {
    private cookieConsentService = inject(CookieConsentService);
    private environmentService = inject(EnvironmentService);
    private idleCallbackService = inject(IdleCallbackService);
    private window = inject(WINDOW);
    private document = inject(DOCUMENT);

    setup() {
        if (this.environmentService.isBrowser()) {
            this.cookieConsentService.consentChanged.subscribe(consentGiven => {
                if (consentGiven) {
                    this.idleCallbackService
                        .idleCallBack()
                        .subscribe(() => this.bootstrapFacebook());
                }
            });
        }
    }

    private bootstrapFacebook() {
        this.initFacebookScript(
            this.window,
            this.document,
            'script',
            'https://connect.facebook.net/en_US/fbevents.js'
        );
        // @ts-ignore
        this.window.fbq('init', '1079394516183897');
        // @ts-ignore
        this.window.fbq('track', 'PageView');
    }

    private initFacebookScript(f, b, e, v, n?, t?, s?) {
        if (f.fbq) return;
        n = f.fbq = function () {
            n.callMethod
                ? n.callMethod.apply(n, arguments)
                : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
    }
}
